(() => {
  const roots = document.querySelectorAll('[data-scc-root]');
  if (!roots.length) return;


  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    const amount = (Number(cents || 0) / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(Number(amount)).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function stripHtml(html) {
    const node = document.createElement('div');
    node.innerHTML = html || '';
    return node.textContent || node.innerText || '';
  }

  roots.forEach((root) => {
    const moneyFormat = root.dataset.moneyFormat || '$' + '{' + '{amount' + '}' + '}';
    if (root.dataset.sccBound === 'true') return;
    root.dataset.sccBound = 'true';

    const toast = root.querySelector('[data-scc-toast]');
    let toastTimer;

    const showToast = (message) => {
      if (!toast) return;
      toast.textContent = message;
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = window.setTimeout(() => {
        toast.hidden = true;
      }, 2800);
    };

    const updateCartCount = async () => {
      try {
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await response.json();

        document.querySelectorAll('.sl-cart-count, .s3-header__mobile-cart > span').forEach((node) => {
          node.textContent = cart.item_count;
          node.hidden = cart.item_count < 1;
        });
      } catch (error) {
        // Cart count update is optional.
      }
    };

    root.querySelectorAll('[data-scc-sort]').forEach((select) => {
      select.addEventListener('change', () => select.form.submit());
    });

    const filterDrawer = root.querySelector('[data-scc-filter-drawer]');
    const openFilters = root.querySelector('[data-scc-open-filters]');
    const closeFilters = root.querySelectorAll('[data-scc-close-filters]');

    if (filterDrawer && openFilters) {
      openFilters.addEventListener('click', () => {
        filterDrawer.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      });

      closeFilters.forEach((button) => {
        button.addEventListener('click', () => {
          filterDrawer.hidden = true;
          document.documentElement.style.overflow = '';
        });
      });
    }

    const grid = root.querySelector('[data-scc-grid-container]');
    const gridButtons = root.querySelectorAll('[data-scc-grid]');

    if (grid) {
      const savedColumns = localStorage.getItem('sensoriumCollectionColumns');
      const defaultColumns = savedColumns || grid.dataset.defaultColumns || '4';
      grid.dataset.columns = defaultColumns;

      gridButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.sccGrid === defaultColumns);
        button.addEventListener('click', () => {
          const columns = button.dataset.sccGrid;
          grid.dataset.columns = columns;
          localStorage.setItem('sensoriumCollectionColumns', columns);
          gridButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        });
      });
    }

    root.querySelectorAll('[data-scc-quick-add]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const original = button ? button.textContent : '';

        if (button) {
          button.disabled = true;
          button.textContent = 'Adding…';
        }

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(new FormData(form))
          });

          if (!response.ok) throw new Error('Unable to add this product.');
          showToast('Added to your ritual bag.');
          await updateCartCount();
        } catch (error) {
          showToast(error.message || 'Unable to add this product.');
        } finally {
          if (button) {
            button.disabled = false;
            button.textContent = original;
          }
        }
      });
    });

    const dialog = root.querySelector('[data-scc-quick-view-dialog]');
    if (!dialog) return;

    const qvImage = dialog.querySelector('[data-scc-qv-image]');
    const qvThumbs = dialog.querySelector('[data-scc-qv-thumbs]');
    const qvVendor = dialog.querySelector('[data-scc-qv-vendor]');
    const qvTitle = dialog.querySelector('[data-scc-qv-title]');
    const qvPrice = dialog.querySelector('[data-scc-qv-price]');
    const qvDescription = dialog.querySelector('[data-scc-qv-description]');
    const qvVariant = dialog.querySelector('[data-scc-qv-variant]');
    const qvForm = dialog.querySelector('[data-scc-qv-form]');
    const qvLink = dialog.querySelector('[data-scc-qv-link]');
    const qvAdd = dialog.querySelector('[data-scc-qv-add]');

    let activeProduct = null;

    function renderImage(src, alt) {
      if (!src) {
        qvImage.removeAttribute('src');
        qvImage.alt = '';
        return;
      }
      qvImage.src = src;
      qvImage.alt = alt || activeProduct?.title || '';
    }

    function updateVariant() {
      if (!activeProduct) return;
      const variant = activeProduct.variants.find((item) => String(item.id) === String(qvVariant.value));
      if (!variant) return;

      qvPrice.textContent = formatMoney(variant.price, moneyFormat);
      qvAdd.disabled = !variant.available;
      qvAdd.textContent = variant.available ? 'Add to bag' : 'Unavailable';

      if (variant.featured_image && variant.featured_image.src) {
        renderImage(variant.featured_image.src, activeProduct.title);
      }
    }

    function openQuickView(product) {
      activeProduct = product;
      qvVendor.textContent = product.vendor || '';
      qvVendor.hidden = !product.vendor;
      qvTitle.textContent = product.title || '';
      qvDescription.textContent = stripHtml(product.description || '').trim();
      qvLink.href = product.url || '#';

      const images = Array.isArray(product.images) ? product.images : [];
      qvThumbs.innerHTML = '';

      const firstImage = images[0] || product.featured_image || '';
      renderImage(typeof firstImage === 'string' ? firstImage : firstImage?.src, product.title);

      images.slice(0, 8).forEach((image, index) => {
        const src = typeof image === 'string' ? image : image?.src;
        if (!src) return;

        const button = document.createElement('button');
        button.type = 'button';
        button.className = index === 0 ? 'is-active' : '';
        button.innerHTML = `<img src="${src}" alt="">`;

        button.addEventListener('click', () => {
          renderImage(src, product.title);
          qvThumbs.querySelectorAll('button').forEach((item) => item.classList.toggle('is-active', item === button));
        });

        qvThumbs.appendChild(button);
      });

      qvVariant.innerHTML = '';
      product.variants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = `${variant.title}${variant.available ? '' : ' — unavailable'}`;
        option.disabled = !variant.available;
        if (variant.id === product.selected_or_first_available_variant?.id) option.selected = true;
        qvVariant.appendChild(option);
      });

      updateVariant();

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.style.overflow = 'hidden';
    }

    root.querySelectorAll('[data-scc-quick-view]').forEach((button) => {
      button.addEventListener('click', () => {
        const script = document.getElementById(button.dataset.productJson);
        if (!script) return;

        try {
          openQuickView(JSON.parse(script.textContent));
        } catch (error) {
          showToast('Quick view could not be opened.');
        }
      });
    });

    qvVariant.addEventListener('change', updateVariant);

    dialog.querySelectorAll('[data-scc-close-quick-view]').forEach((button) => {
      button.addEventListener('click', () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        document.documentElement.style.overflow = '';
      });
    });

    dialog.addEventListener('cancel', () => {
      document.documentElement.style.overflow = '';
    });

    qvForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      qvAdd.disabled = true;
      const original = qvAdd.textContent;
      qvAdd.textContent = 'Adding…';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: new URLSearchParams(new FormData(qvForm))
        });

        if (!response.ok) throw new Error('Unable to add this product.');
        showToast('Added to your ritual bag.');
        await updateCartCount();
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        document.documentElement.style.overflow = '';
      } catch (error) {
        showToast(error.message || 'Unable to add this product.');
      } finally {
        qvAdd.disabled = false;
        qvAdd.textContent = original;
      }
    });
  });
})();
